import React, { useState, useEffect } from 'react'

import { getFullName } from '../../../utils'

const AssigneeCentralUser = ({ row }) => {
    const [openToAssignAndAssigneeUserStatus, setOpenToAssignAndAssigneeUserStatus] = useState({
        showAssigneeUser: false,
        showOpenToAssign: false
    })

    const getOpenToAssignAndAssigneeUserStatus = (materialItemData) => {
        const currentTime = new Date()
        const createdAtDate = new Date(materialItemData["createdAt"])
        const updatedAtDate = new Date(materialItemData["updatedAt"])

        const createdAtTime = createdAtDate.getTime()
        const updatedAtTime = updatedAtDate.getTime()

        let timeSinceCreated = currentTime - createdAtDate
        let oneHourInMillis = 3600000
        let twoSeconds = 2000

        let showAssigneeUser = false
        let showOpenToAssign = false

        if (timeSinceCreated < oneHourInMillis && (createdAtTime > (updatedAtTime - twoSeconds)) && createdAtTime < (updatedAtTime + twoSeconds)) {
            showAssigneeUser = true
            showOpenToAssign = true
        } else if ((createdAtTime < updatedAtTime - twoSeconds) && (timeSinceCreated < oneHourInMillis || timeSinceCreated > oneHourInMillis)) {
            showAssigneeUser = true
        } else if (timeSinceCreated > oneHourInMillis && (createdAtTime > (updatedAtTime - twoSeconds)) && createdAtTime < (updatedAtTime + twoSeconds)) {
            showOpenToAssign = true
        } else {
            showAssigneeUser = true
        }

        return { showAssigneeUser, showOpenToAssign }
    }

    

    useEffect(() => {
        const status = getOpenToAssignAndAssigneeUserStatus(row)
        setOpenToAssignAndAssigneeUserStatus(status)

        const intervalId = setInterval(() => {
            const status = getOpenToAssignAndAssigneeUserStatus(row)
            setOpenToAssignAndAssigneeUserStatus(status)
        }, 30000)

        return () => clearInterval(intervalId)
    }, [row])

    const { showAssigneeUser, showOpenToAssign } = openToAssignAndAssigneeUserStatus

    let assigneeUserName = getFullName(row["assigneeUserFirstName"], row["assigneeUserLastName"])

    return (
        <>
            {showAssigneeUser ? assigneeUserName : null}
            {showOpenToAssign ? (
                <>
                    <br />
                    <a style={{ fontSize: '13px', color: '#3366cc' }}>
                        {"Open to Assign"}
                    </a>
                </>
            ) : null}
        </>
    )
}

export default AssigneeCentralUser
